.exp-page {
	padding: 20px;
}
